import { Flex } from 'components/base/layout-components';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';
import usePmProvider from 'components/hooks/PM/usePmProvider';
import { PM_PROVIDERS } from 'common/constants/constants';

const headerTextMapByProvider = {
  [PM_PROVIDERS.JIRA]: 'Issue Count',
  [PM_PROVIDERS.AZURE_BOARDS]: 'Work Item Count'
};

export const Header = () => {
  const pmProvider = usePmProvider();
  return (
    <Flex items='center' mb='small'>
      <Icon name='Settings' size='small' color='black' isThin />
      <Text size='x-x-large' ml='1rem'>
        {headerTextMapByProvider[pmProvider]}
      </Text>
    </Flex>
  );
};
